module.exports = __webpack_public_path__ + "img/Location.00ed8f6c.svg";